import { getZrmUserInfo } from '@zg-rentals/clickstream';
import { trackUserEvent } from '../../analytics';
import { SEMANTIC_EVENT_NAME, TOPIC_TAG_TXT, TRIGGER_LOCATION, TRIGGER_OBJECT, TRIGGER_TYPE } from './globals';
import type { ZrmClickstreamUserOrNull } from '../../analytics/types';

const EVENT_TEMPLATE_ID = '167';

// https://dataportal.zillowgroup.net/event-registry/3883
export const STAR_CONVERSATION_EVENT_TYPE_ID = '3883';
export const emitStarConversationEvent = (user: ZrmClickstreamUserOrNull) =>
  trackUserEvent({
    envelope: {
      event_type_id: STAR_CONVERSATION_EVENT_TYPE_ID,
      event_type_version_id: '1',
      event_template_id: EVENT_TEMPLATE_ID,
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction,
      trigger_location_nm: TRIGGER_LOCATION.IreneInbox,
      trigger_source_nm: 'favorite_conversation_icon',
      trigger_object_nm: TRIGGER_OBJECT.NoTriggerObject,
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.ManageLead,
      topic_tag_txt: [TOPIC_TAG_TXT.ZrmSatellite],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/3884
export const STARRED_CONVERSATIONS_FILTER_EVENT_TYPE_ID = '3884';
export const emitStarredConversationsFilterEvent = (user: ZrmClickstreamUserOrNull) =>
  trackUserEvent({
    envelope: {
      event_type_id: STARRED_CONVERSATIONS_FILTER_EVENT_TYPE_ID,
      event_type_version_id: '2',
      event_template_id: EVENT_TEMPLATE_ID,
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction,
      trigger_location_nm: TRIGGER_LOCATION.IreneInbox,
      trigger_source_nm: 'starred_conversation_filter',
      trigger_object_nm: TRIGGER_OBJECT.NoTriggerObject,
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.ManageLead,
      topic_tag_txt: [TOPIC_TAG_TXT.ZrmSatellite],
    },
    ...getZrmUserInfo(user),
  });
